import React, { useLayoutEffect, useState, useMemo, useCallback } from "react";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../../../assets/hooks/hooks";
import { useGetProductsListQuery } from "../../../../redux/RTKQuery/api";
import { uiSlicedActions } from "../../../../redux/ui-slice";
import SubRowHistoryText from "../Components/SubRowHistoryText";
import { ProductMapping, Action } from "../Product/HistoryProductModel";
import InformTable from "../Components/InformTable";

import "../Components/InformTable.scss";

const MigrationCreated: React.FC<{ action: Action }> = ({ action }) => {
    const [hasFetched, setHasFetched] = useState(false);
    const dispatch = useAppDispatch();

    const {
        data: products,
        isLoading: isLoadingProducts,
        isSuccess: isSuccessProducts,
        isError: isErrorProducts,
    } = useGetProductsListQuery(
        {},
        { skip: hasFetched || typeof action === "string" },
    );

    useLayoutEffect(() => {
        if (isSuccessProducts) setHasFetched(true);
        if (isErrorProducts) toast.error("Error fetching products");
    }, [isSuccessProducts, isErrorProducts]);

    useLayoutEffect(() => {
        dispatch(
            uiSlicedActions.setLoading(
                isLoadingProducts ? "pending" : "hidden",
            ),
        );
    }, [isLoadingProducts, dispatch]);

    const getProductName = useCallback(
        (productId: number) => {
            return products?.products.find(
                (product: { id: number; name: string }) =>
                    product.id === productId,
            )?.name;
        },
        [products],
    );

    const productMappings = useMemo(() => {
        if (typeof action === "string") return [];
        return (action.ProductMappings ?? []).map((productMapping) => ({
            ...productMapping,
            actualProductName: getProductName(productMapping.value.ProductId),
        }));
    }, [action, getProductName]);

    if (typeof action === "string") {
        return <SubRowHistoryText action={action} />;
    }

    if (productMappings.length === 0) {
        const forceOverride = (action as any).Options?.ForceOverride;
        return (
            <div className="inform_panel">
                <InformTable
                    label="Options"
                    data={[
                        {
                            property: "Force Override",
                            value: String(forceOverride ?? "—"),
                        },
                    ]}
                />
            </div>
        );
    }

    const renderProductMapping = (
        productMapping: ProductMapping & { actualProductName?: string },
    ) => (
        <div className="inform_panel" key={productMapping.index}>
            <InformTable
                label="Product"
                data={[
                    {
                        property: "Upclick Product ID:",
                        value: productMapping.value.UpclickProductId,
                    },
                    {
                        property: "Original Product Name:",
                        value: productMapping.value.Alias,
                    },
                    {
                        property: "Actual Product Name:",
                        value: productMapping.actualProductName ?? "",
                    },
                ]}
            />
        </div>
    );

    return <>{productMappings.map(renderProductMapping)}</>;
};

export default MigrationCreated;
